import { Directive, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription, startWith, map } from 'rxjs';
import { interval } from 'rxjs/internal/observable/interval';

export const SAVE_INTERVAL = 5000;

@Directive({
  selector: '[appFocusAutosave]'
})
export class FocusAutosaveDirective implements OnDestroy {
    @Output() appFocusAutosave = new EventEmitter<void>();

    private updateInterval?: Subscription;

    constructor() { }

    @HostListener('onFocusIn')  // @tinymce Focus In event capture
    @HostListener('focusin')
    @HostListener('focus')      // input Focus In event capture
    onFocus() {
        this.updateInterval?.unsubscribe();
        this.updateInterval = interval(SAVE_INTERVAL)
            .pipe(
                map(() => this.appFocusAutosave.emit())
            ).subscribe();
    }


    @HostListener('onFocusOut') // @tinymce Focus Out event capture
    @HostListener('focusout')   // input Focus Out event capture
    onFocusOut() {
        this.updateInterval?.unsubscribe();
        this.appFocusAutosave.emit();
    }

    ngOnDestroy(): void {
        this.updateInterval?.unsubscribe();
        this.appFocusAutosave.emit();
    }
}
